import types from '../actionTypes';

export const setTaskList = tasks => {
    return dispatch => {

        dispatch({ type: types.SET_TASKLIST, tasks });
    }
}
